module.exports = __webpack_public_path__ + "media/choosing_a_college/University_sign_max120w-98b19276.jpg";